import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import Typography from '@mui/material/Typography'
import { colors } from '@global/constants/colors'
import * as css from '../styles'
import { t } from '@lingui/core/macro'

export const DefaultSuccessPhase = () => {
  return (
    <css.DialogContentStyled>
      <CheckCircleIcon style={{ color: colors.green.light, fontSize: '50px', margin: '20px' }} />
      <css.SuccessMessage>
        <Typography variant="h4">{t`Successfully uploaded!`}</Typography>
        <Typography variant="body1" style={{ padding: '20px 64px', textAlign: 'center' }}>
          {t`File uploaded successfully!`}
        </Typography>
      </css.SuccessMessage>
    </css.DialogContentStyled>
  )
}
